export const mediaSections = [
  {
    id: 'testimonies',
    title: 'Testimonies',
    shortTitle: 'Testimonies',
    description: 'Stories that awaken faith, courage, repentance, and hope.',
    accent: 'Hope',
    items: [
      {
        title: 'Delafe Testimonies',
        source: 'Mission Delafe',
        type: 'Video archive',
        url: 'https://www.missiondelafe.org/',
        summary: 'A large and growing archive of people telling how Jesus met them, rescued them, healed them, and changed their lives.',
        tags: ['testimony', 'evangelism', 'deliverance'],
      },
      {
        title: 'Delafe Testimonies YouTube Channel',
        source: 'YouTube',
        type: 'Video channel',
        url: 'https://www.youtube.com/@delafetestimonies',
        summary: 'Short and long-form testimonies that can help people encounter the living God through ordinary people telling the truth.',
        tags: ['testimony', 'gospel', 'video'],
      },
      {
        title: 'Imagine Heaven',
        source: 'John Burke',
        type: 'Book and talks',
        url: 'https://imagineheaven.net/',
        summary: 'Near-death-experience accounts considered through a Christian lens, useful for conversations about eternity and hope.',
        tags: ['eternity', 'testimony', 'hope'],
      },
      {
        title: 'I Am Second',
        source: 'I Am Second',
        type: 'Video stories',
        url: 'https://www.iamsecond.com/',
        summary: 'Personal stories from people who met Christ in fame, pain, addiction, success, and collapse.',
        tags: ['testimony', 'identity', 'discipleship'],
      },
      {
        title: 'CBN Stories',
        source: 'CBN',
        type: 'Video stories',
        url: 'https://www2.cbn.com/stories',
        summary: 'Faith stories covering healing, provision, recovery, family restoration, and encounters with God.',
        tags: ['testimony', 'healing', 'provision'],
      },
      {
        title: '700 Club Interactive Testimonies',
        source: 'CBN',
        type: 'Video stories',
        url: 'https://www2.cbn.com/700-club-interactive',
        summary: 'Stories and conversations that can help people see faith as something lived, not merely argued.',
        tags: ['testimony', 'conversation', 'faith'],
      },
      {
        title: 'Faith on the Edge',
        source: 'Global Christian Relief',
        type: 'Persecuted church stories',
        url: 'https://globalchristianrelief.org/',
        summary: 'Stories from believers living under pressure, persecution, displacement, and loss.',
        tags: ['persecution', 'testimony', 'courage'],
      },
      {
        title: 'Open Doors Stories',
        source: 'Open Doors',
        type: 'Persecuted church reports',
        url: 'https://www.opendoors.org/en-US/stories/',
        summary: 'Accounts of Christians who follow Jesus where faith can cost family, safety, livelihood, or life.',
        tags: ['persecution', 'testimony', 'missions'],
      },
      {
        title: 'Muslim Background Believer Stories',
        source: 'SAT-7',
        type: 'Stories and ministry reports',
        url: 'https://www.sat7usa.org/',
        summary: 'Stories from the Middle East and North Africa where people encounter Christ through broadcasts, dreams, and faithful witness.',
        tags: ['middle-east', 'testimony', 'evangelism'],
      },
      {
        title: 'Jesus Film Stories',
        source: 'Jesus Film Project',
        type: 'Mission stories',
        url: 'https://www.jesusfilm.org/stories/',
        summary: 'Reports of people meeting Jesus through translated media and local witness in many nations.',
        tags: ['gospel', 'translation', 'missions'],
      },
    ],
  },
  {
    id: 'world-needs',
    title: 'World Needs',
    shortTitle: 'World Needs',
    description: 'War, trafficking, hunger, persecution, disaster, addiction, and places where people need the Body of Christ to see them.',
    accent: 'Mercy',
    items: [
      {
        title: 'World Watch List',
        source: 'Open Doors',
        type: 'Annual report',
        url: 'https://www.opendoors.org/en-US/persecution/countries/',
        summary: 'A country-by-country window into where Christians are pressured, watched, imprisoned, attacked, or driven from home.',
        tags: ['persecution', 'evangelism', 'global'],
      },
      {
        title: 'Stories of Rescue',
        source: 'International Justice Mission',
        type: 'Rescue stories',
        url: 'https://www.ijm.org/stories',
        summary: 'Real stories of people rescued from trafficking, forced labor, violence, and abuse of power.',
        tags: ['trafficking', 'justice', 'survivors'],
      },
      {
        title: 'Trafficking and Slavery',
        source: 'International Justice Mission',
        type: 'Issue explainer',
        url: 'https://www.ijm.org/our-work/trafficking-slavery',
        summary: 'A focused look at modern slavery and the people trapped inside systems that profit from fear and poverty.',
        tags: ['trafficking', 'slavery', 'exploitation'],
      },
      {
        title: 'Global Hunger Overview',
        source: 'World Food Programme',
        type: 'Issue hub',
        url: 'https://www.wfp.org/global-hunger-crisis',
        summary: 'Tracks hunger crises and food insecurity where families are running out of ordinary ways to survive.',
        tags: ['hunger', 'food-security', 'relief'],
      },
      {
        title: 'Global Trends Report',
        source: 'UNHCR',
        type: 'Displacement report',
        url: 'https://www.unhcr.org/global-trends',
        summary: 'Shows how war, persecution, and disaster uproot families and scatter people across borders.',
        tags: ['refugees', 'displacement', 'war'],
      },
      {
        title: 'Children and Armed Conflict',
        source: 'United Nations',
        type: 'Report hub',
        url: 'https://childrenandarmedconflict.un.org/',
        summary: 'Tracks the cost of war on children: recruitment, killing, maiming, abduction, and attacks on schools.',
        tags: ['children', 'war', 'protection'],
      },
      {
        title: 'War in Cities',
        source: 'International Committee of the Red Cross',
        type: 'Humanitarian analysis',
        url: 'https://www.icrc.org/en/what-we-do/urban-warfare',
        summary: 'Explains why modern urban war crushes civilians, hospitals, water systems, families, and ordinary life.',
        tags: ['war', 'cities', 'civilians'],
      },
      {
        title: 'Global Report on Trafficking in Persons',
        source: 'UNODC',
        type: 'Global report',
        url: 'https://www.unodc.org/unodc/en/human-trafficking/global-report-on-trafficking-in-persons.html',
        summary: 'A global look at trafficking patterns, exploitation, and the way predators adapt to poverty and instability.',
        tags: ['trafficking', 'data', 'global'],
      },
      {
        title: 'Human Trafficking Hotline',
        source: 'Polaris',
        type: 'Data and survivor signals',
        url: 'https://humantraffickinghotline.org/en/statistics',
        summary: 'U.S. trafficking data that helps people understand how exploitation is reported and where warning signs appear.',
        tags: ['trafficking', 'hotline', 'usa'],
      },
      {
        title: 'Addiction and Overdose Data',
        source: 'CDC',
        type: 'Public health data',
        url: 'https://www.cdc.gov/overdose-prevention/data-research/facts-stats/index.html',
        summary: 'A sober view of overdose and addiction trends affecting families, churches, and communities.',
        tags: ['addiction', 'recovery', 'families'],
      },
    ],
  },
  {
    id: 'truth-bias',
    title: 'Truth & Bias',
    shortTitle: 'Truth & Bias',
    description: 'Tools and habits for testing claims without becoming cynical, cold, or easily manipulated.',
    accent: 'Discernment',
    items: [
      {
        title: 'Ground News',
        source: 'Ground News',
        type: 'Bias comparison',
        url: 'https://ground.news/',
        summary: 'Compare how sources across the political spectrum cover the same story and notice what your normal feed may hide.',
        tags: ['bias', 'news', 'comparison'],
      },
      {
        title: 'Ground News Bias Bar',
        source: 'Ground News',
        type: 'Tool explainer',
        url: 'https://ground.news/bias-bar',
        summary: 'A simple way to see whether a story is being carried more heavily by left, center, or right sources.',
        tags: ['bias', 'source-checking', 'news'],
      },
      {
        title: 'AllSides Media Bias Chart',
        source: 'AllSides',
        type: 'Source guide',
        url: 'https://www.allsides.com/media-bias/media-bias-chart',
        summary: 'A quick reference for comparing source leanings and building a wider information diet.',
        tags: ['bias', 'media-literacy', 'sources'],
      },
      {
        title: 'Interactive Media Bias Chart',
        source: 'Ad Fontes Media',
        type: 'Source guide',
        url: 'https://adfontesmedia.com/interactive-media-bias-chart/',
        summary: 'Maps news sources by reliability and bias so readers can separate reporting from opinion and outrage.',
        tags: ['reliability', 'bias', 'discernment'],
      },
      {
        title: 'Reuters Fact Check',
        source: 'Reuters',
        type: 'Fact check',
        url: 'https://www.reuters.com/fact-check/',
        summary: 'A useful place to test viral claims against reporting standards and documented evidence.',
        tags: ['fact-check', 'verification', 'news'],
      },
      {
        title: 'AP Fact Check',
        source: 'Associated Press',
        type: 'Fact check',
        url: 'https://apnews.com/hub/ap-fact-check',
        summary: 'Checks public claims, images, videos, and viral narratives that can distort public understanding.',
        tags: ['fact-check', 'claims', 'news'],
      },
      {
        title: 'Snopes',
        source: 'Snopes',
        type: 'Fact check',
        url: 'https://www.snopes.com/',
        summary: 'A long-running fact-checking source for viral stories, rumors, manipulated images, and internet claims.',
        tags: ['fact-check', 'rumors', 'verification'],
      },
      {
        title: 'News Literacy Project',
        source: 'News Literacy Project',
        type: 'Media literacy',
        url: 'https://newslit.org/',
        summary: 'Training and resources that help people slow down, check sources, and avoid being captured by emotional manipulation.',
        tags: ['media-literacy', 'discernment', 'education'],
      },
      {
        title: 'Bellingcat Guides',
        source: 'Bellingcat',
        type: 'Open-source verification',
        url: 'https://www.bellingcat.com/category/resources/how-tos/',
        summary: 'Practical guides for checking images, locations, timelines, and claims using open-source investigation methods.',
        tags: ['verification', 'osint', 'sources'],
      },
      {
        title: 'CISA Rumor Control',
        source: 'CISA',
        type: 'Civic misinformation resource',
        url: 'https://www.cisa.gov/rumor-control',
        summary: 'A model for calmly answering rumors with direct claims, evidence, and sources instead of panic.',
        tags: ['misinformation', 'claims', 'civic'],
      },
    ],
  },
  {
    id: 'learn-build',
    title: 'Learn & Build',
    shortTitle: 'Learn & Build',
    description: 'Practical resources that move people from concern to skill, wisdom, and real capability.',
    accent: 'Skill',
    items: [
      {
        title: 'BibleProject: Justice',
        source: 'BibleProject',
        type: 'Biblical explainer',
        url: 'https://bibleproject.com/explore/video/justice/',
        summary: 'A biblical foundation for justice that starts with God’s character and moves toward how people treat each other.',
        tags: ['justice', 'scripture', 'formation'],
      },
      {
        title: 'BibleProject: Generosity',
        source: 'BibleProject',
        type: 'Biblical explainer',
        url: 'https://bibleproject.com/explore/video/generosity/',
        summary: 'A scriptural lens for generosity, provision, and what it means to hold resources open-handed before God.',
        tags: ['generosity', 'stewardship', 'scripture'],
      },
      {
        title: 'Crown Financial Ministries',
        source: 'Crown',
        type: 'Financial discipleship',
        url: 'https://www.crown.org/',
        summary: 'Christian financial teaching for stewardship, debt, work, giving, and living with financial wisdom.',
        tags: ['stewardship', 'debt-freedom', 'money'],
      },
      {
        title: 'Ramsey Solutions: Debt',
        source: 'Ramsey Solutions',
        type: 'Financial education',
        url: 'https://www.ramseysolutions.com/debt',
        summary: 'Plain-language resources for people trying to escape debt and rebuild household financial margin.',
        tags: ['debt-freedom', 'household', 'finance'],
      },
      {
        title: 'Permaculture Research Institute',
        source: 'PRI',
        type: 'Food and land learning',
        url: 'https://www.permaculturenews.org/',
        summary: 'Practical thinking for food systems, soil, water, homesteading, and long-term resilience.',
        tags: ['permaculture', 'food-security', 'land'],
      },
      {
        title: 'A Rocha',
        source: 'A Rocha International',
        type: 'Christian creation care',
        url: 'https://arocha.org/',
        summary: 'Christian conservation work connecting faith, land, stewardship, and care for creation.',
        tags: ['creation-care', 'stewardship', 'environment'],
      },
      {
        title: 'Habitat for Humanity Housing Knowledge',
        source: 'Habitat for Humanity',
        type: 'Housing resources',
        url: 'https://www.habitat.org/emea/about/what-we-do/residential-construction',
        summary: 'Practical housing and construction thinking for communities trying to shelter families affordably.',
        tags: ['housing', 'construction', 'families'],
      },
      {
        title: 'Strong Towns',
        source: 'Strong Towns',
        type: 'Local resilience',
        url: 'https://www.strongtowns.org/',
        summary: 'Useful analysis for making towns financially resilient, walkable, productive, and less fragile.',
        tags: ['localism', 'infrastructure', 'resilience'],
      },
      {
        title: 'The Chalmers Center',
        source: 'Chalmers Center',
        type: 'Poverty alleviation',
        url: 'https://chalmers.org/',
        summary: 'Christian training on poverty, dignity, work, and helping without harming.',
        tags: ['poverty', 'dignity', 'service'],
      },
      {
        title: 'Peacemaker Ministries',
        source: 'Peacemaker Ministries',
        type: 'Conflict training',
        url: 'https://rw360.org/',
        summary: 'Biblical conflict-resolution training that can strengthen TYK’s formal resolver workflows.',
        tags: ['conflict-resolution', 'reconciliation', 'training'],
      },
    ],
  },
  {
    id: 'kingdom-economy',
    title: 'Kingdom Economy',
    shortTitle: 'Kingdom Economy',
    description: 'Markets, money, work, ethical supply chains, and business practices that help people build without exploiting each other.',
    accent: 'Stewardship',
    items: [
      {
        title: 'Bitcoin.org: Getting Started',
        source: 'Bitcoin.org',
        type: 'Bitcoin basics',
        url: 'https://bitcoin.org/en/getting-started',
        summary: 'A neutral starting place for understanding Bitcoin payments, wallets, and personal responsibility.',
        tags: ['bitcoin', 'wallets', 'payments'],
      },
      {
        title: 'River Learn',
        source: 'River',
        type: 'Bitcoin education',
        url: 'https://river.com/learn/',
        summary: 'Clear Bitcoin explainers for people who need to understand custody, settlement, and monetary basics.',
        tags: ['bitcoin', 'education', 'stewardship'],
      },
      {
        title: 'Mempool Space',
        source: 'mempool.space',
        type: 'Bitcoin network data',
        url: 'https://mempool.space/',
        summary: 'Live Bitcoin fee and block data that can help users understand transaction timing and evidence.',
        tags: ['bitcoin', 'fees', 'transactions'],
      },
      {
        title: 'KnowTheChain',
        source: 'KnowTheChain',
        type: 'Forced labor benchmarks',
        url: 'https://knowthechain.org/',
        summary: 'Research on forced-labor risk in corporate supply chains, useful for future marketplace trust badges.',
        tags: ['supply-chain', 'forced-labor', 'business'],
      },
      {
        title: 'Responsible Sourcing Tool',
        source: 'U.S. Department of State',
        type: 'Supply chain guidance',
        url: 'https://www.responsiblesourcingtool.org/',
        summary: 'Practical guidance for spotting and reducing trafficking risk in supply chains.',
        tags: ['supply-chain', 'trafficking', 'business'],
      },
      {
        title: 'Fairtrade Standards',
        source: 'Fairtrade International',
        type: 'Standards',
        url: 'https://www.fairtrade.net/standard',
        summary: 'A reference point for thinking about certification, producer dignity, and transparent marketplace claims.',
        tags: ['certification', 'trade', 'standards'],
      },
      {
        title: 'B Lab Standards',
        source: 'B Lab',
        type: 'Business standards',
        url: 'https://www.bcorporation.net/en-us/standards/',
        summary: 'A useful outside model for measuring business impact, organizational practices, workers, community, and environment.',
        tags: ['business', 'standards', 'trust'],
      },
      {
        title: 'Open Food Network',
        source: 'Open Food Network',
        type: 'Local food marketplace',
        url: 'https://www.openfoodnetwork.org/',
        summary: 'A model for connecting local producers, buyers, food hubs, and community food systems.',
        tags: ['food-security', 'marketplace', 'local'],
      },
      {
        title: 'USDA Local Food Directories',
        source: 'USDA',
        type: 'Local food data',
        url: 'https://www.ams.usda.gov/local-food-directories',
        summary: 'A practical source for thinking about food producers, markets, and local supply resilience.',
        tags: ['food-security', 'local', 'markets'],
      },
      {
        title: 'Christian Business Men’s Connection',
        source: 'CBMC',
        type: 'Marketplace ministry',
        url: 'https://www.cbmc.com/',
        summary: 'A business-ministry model for integrating work, discipleship, leadership, and witness.',
        tags: ['business', 'discipleship', 'work'],
      },
    ],
  },
  {
    id: 'missions-worship',
    title: 'Missions & Worship',
    shortTitle: 'Missions',
    description: 'Resources that help believers pray, worship, understand unreached places, and carry the Gospel with love.',
    accent: 'Gospel',
    items: [
      {
        title: 'Joshua Project',
        source: 'Joshua Project',
        type: 'Unreached peoples data',
        url: 'https://joshuaproject.net/',
        summary: 'Data and prayer resources for unreached people groups and places where Gospel access is limited.',
        tags: ['evangelism', 'unreached', 'prayer'],
      },
      {
        title: 'Prayercast',
        source: 'Prayercast',
        type: 'Prayer videos',
        url: 'https://www.prayercast.com/',
        summary: 'Videos that help believers pray for nations, people groups, and urgent spiritual needs.',
        tags: ['prayer', 'nations', 'evangelism'],
      },
      {
        title: 'Operation World',
        source: 'Operation World',
        type: 'Prayer guide',
        url: 'https://operationworld.org/',
        summary: 'A global guide for praying with understanding for nations, churches, needs, and mission opportunities.',
        tags: ['prayer', 'missions', 'nations'],
      },
      {
        title: 'Lausanne Movement',
        source: 'Lausanne',
        type: 'Mission thought leadership',
        url: 'https://lausanne.org/',
        summary: 'Global Christian mission conversations on evangelism, discipleship, culture, and witness.',
        tags: ['missions', 'evangelism', 'global-church'],
      },
      {
        title: 'Faith Comes By Hearing',
        source: 'Faith Comes By Hearing',
        type: 'Audio Bible mission',
        url: 'https://www.faithcomesbyhearing.com/',
        summary: 'Scripture access through audio Bible translation and distribution across languages.',
        tags: ['scripture', 'translation', 'audio'],
      },
      {
        title: 'YouVersion Bible App',
        source: 'YouVersion',
        type: 'Bible platform',
        url: 'https://www.youversion.com/',
        summary: 'A widely used Bible platform that helps people read, listen, share, and form Scripture habits.',
        tags: ['scripture', 'discipleship', 'mobile'],
      },
      {
        title: '24-7 Prayer',
        source: '24-7 Prayer',
        type: 'Prayer movement',
        url: 'https://www.24-7prayer.com/',
        summary: 'A global prayer movement with practices, rooms, communities, and tools for sustained prayer.',
        tags: ['prayer', 'community', 'formation'],
      },
      {
        title: 'The Bible Recap',
        source: 'The Bible Recap',
        type: 'Bible reading plan',
        url: 'https://www.thebiblerecap.com/',
        summary: 'A structured path for people who want to understand Scripture more deeply and consistently.',
        tags: ['scripture', 'discipleship', 'learning'],
      },
      {
        title: 'Alpha',
        source: 'Alpha',
        type: 'Evangelism course',
        url: 'https://alpha.org/',
        summary: 'A conversational way for people to explore faith, ask questions, and encounter the Gospel in community.',
        tags: ['evangelism', 'questions', 'community'],
      },
      {
        title: 'Worship Together',
        source: 'Worship Together',
        type: 'Worship resources',
        url: 'https://www.worshiptogether.com/',
        summary: 'Worship songs, charts, and resources that can help churches and circles gather around praise.',
        tags: ['worship', 'music', 'church'],
      },
    ],
  },
];

export const mediaCategoryOptions = mediaSections.map(({ id, title }) => ({ id, title }));
